/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsStationSettingsQueryResponse, GetLiveTopicsStationSettingsPathParams } from "../models/GetLiveTopicsStationSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLiveTopicsStationSettings } from "../axios/getLiveTopicsStationSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLiveTopicsStationSettingsQueryKey = (entityId: GetLiveTopicsStationSettingsPathParams["entityId"]) => ["nlp-integration-api", { url: '/live-topics/station-settings/:entityId', params: {entityId:entityId} }] as const

export type GetLiveTopicsStationSettingsQueryKey = ReturnType<typeof getLiveTopicsStationSettingsQueryKey>

export function getLiveTopicsStationSettingsQueryOptions(entityId: GetLiveTopicsStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLiveTopicsStationSettingsQueryKey(entityId)
        return queryOptions<GetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<Error>, GetLiveTopicsStationSettingsQueryResponse, typeof queryKey>({
         enabled: !!(entityId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLiveTopicsStationSettings(entityId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Get settings for a specific station (client access)
 * @summary Get station settings
 * {@link /live-topics/station-settings/:entityId}
 */
export function useGetLiveTopicsStationSettings<TData = GetLiveTopicsStationSettingsQueryResponse, TQueryData = GetLiveTopicsStationSettingsQueryResponse, TQueryKey extends QueryKey = GetLiveTopicsStationSettingsQueryKey>(entityId: GetLiveTopicsStationSettingsPathParams["entityId"], options: 
{
  query?: Partial<QueryObserverOptions<GetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getLiveTopicsStationSettingsQueryKey(entityId)
         

         const query = useQuery({
          ...getLiveTopicsStationSettingsQueryOptions(entityId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}